import React from 'react';
import {useRouter} from 'next/router';

import GuidePage from '../../../js/pages/GuidePage';
import PageContainer from '../../../js/components/PageContainer';

import {getGuide, getLessonToCourseMapping} from '../../../../server/services/cms';
import {getMaps} from '../../../../server/services/tags';

export default function Page({guide, lessonMapping}) {
  const {query: {slugOrCompany: slug}} = useRouter();
  return (
    <GuidePage
      slug={slug}
      guide={guide}
      lessonMapping={lessonMapping}
    />
  );
}

Page.getLayout = (page) => (
  <PageContainer stickyHeader>
    {page}
  </PageContainer>
);

export async function getStaticProps({params}) {
  // lessonMapping: Helps construct lesson URLs using a mapping from lesson slug to course slug
  const [guide, lessonMapping, {roleMapId, companyMapId}] = await Promise.all([
    getGuide(params.slugOrCompany),
    getLessonToCourseMapping(),
    getMaps(),
  ]);

  // Use custom role name if custom role name is present
  if (guide) guide.roleName = guide.roleName || roleMapId[guide.roleTag]?.name || '';
  else return {notFound: true};

  // To make the guide serializable as JSON in the presence of undefined values
  Object.keys(guide).forEach((key) => {
    if (guide[key] === undefined) {
      guide[key] = null;
    }
  });

  return {
    props: {
      guide: JSON.parse(JSON.stringify(guide)),
      lessonMapping,
    },
    revalidate: 60,
  };
}

// See https://nextjs.org/docs/api-reference/data-fetching/get-static-paths
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}
